import axios from "axios";
import { ProgramSetupAxios } from "./API";

// return promise
let leftNavCT = axios.CancelToken.source();
export const LeftNavigation = (url) => {
    leftNavCT.cancel();
    leftNavCT = axios.CancelToken.source();
    return new Promise((resolve, reject) => {
        ProgramSetupAxios.get(url, { cancelToken: leftNavCT.token })
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
    });
};



